import { __assign, __extends } from "tslib";
import React from 'react';
var PrintOnlyImageSource = /** @class */ (function (_super) {
    __extends(PrintOnlyImageSource, _super);
    function PrintOnlyImageSource(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isPrinting: false,
        };
        return _this;
    }
    PrintOnlyImageSource.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('beforeprint', function () {
            _this.setState({ isPrinting: true });
        });
        window.addEventListener('afterprint', function () {
            _this.setState({ isPrinting: false });
        });
    };
    PrintOnlyImageSource.prototype.render = function () {
        return this.state.isPrinting ? React.createElement("source", __assign({}, this.props)) : null;
    };
    return PrintOnlyImageSource;
}(React.Component));
export { PrintOnlyImageSource };
//# sourceMappingURL=printOnlySource.js.map